import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Image, useDeviceType } from '@cian/ui-kit';

import { MainNews } from '../../components/MainNews';
import { selectMainNews } from '../../selectors/mainNews';
import { selectTopMainArticle } from '../../selectors/mainArticles';
import { MainArticleDetailed, MainArticleSimplified } from '../../components/MainArticle';
import { TThunkDispatch } from '../../types/redux';
import { getMainNews } from '../../actions/mainNews';
import { ERequestStatus } from '../../types/requestStatus';
import { NotFound } from '../../components/NotFound';
import { IArticlesMainAttributesRubricSchema } from '../../repositories/journal/entities/journal/ArticlesMainAttributesRubricSchema';
import { MAIN_NEWS_REQUEST_LIMIT } from '../../constants';
import { EType } from '../../repositories/journal/entities/journal/JournalListAttributesSchema';
import { buildPostUrl } from '../../utils';
import * as s from './MainArticleAndMainNewsContainer.css';

/** Главная статья и блок новостей на Главной */
export const MainArticleAndMainNewsContainer = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const { search } = useLocation();
  const [withTag, setWithTag] = useState(new URLSearchParams(search).get('with-tag') || '');
  const history = useHistory();
  const deviceType = useDeviceType();
  const isPhone = () => deviceType === 'phone';
  const mainNews = useSelector(selectMainNews);
  const mainArticle = useSelector(selectTopMainArticle);

  /**
   * Запрашиваем список новостей, если еще ни разу не запрашивали (1)
   * или сменился with-tag в qs (2)
   */
  useEffect(() => {
    const qsWithTag = new URLSearchParams(search).get('with-tag') || '';

    if (qsWithTag !== withTag || mainNews.status === ERequestStatus.Initial) {
      dispatch(getMainNews({ limit: MAIN_NEWS_REQUEST_LIMIT, tag: qsWithTag })).finally();
    }

    if (qsWithTag !== withTag) {
      setWithTag(qsWithTag);
    }
  }, [dispatch, mainNews.status, search, withTag]);

  /** Роутит по клику по рубрике */
  const handleRubricButtonClick = (url: IArticlesMainAttributesRubricSchema['url']) => {
    history.push(url);
  };

  /** Роутит по клику по статье */
  const handleArticleClick = (url: string) => {
    history.push(url);
  };

  if (!mainArticle && !mainNews?.items?.length) {
    return <NotFound />;
  }

  return (
    <div className={s['wrapper']}>
      <div className={s['main-article-wrapper']}>
        {mainArticle &&
          (isPhone() ? (
            <MainArticleSimplified
              title={mainArticle.attributes.title}
              image={mainArticle.attributes.image}
              url={buildPostUrl({ type: EType.Articles, slug: mainArticle.attributes.slug, id: mainArticle.id })}
              onClick={() =>
                handleArticleClick(
                  buildPostUrl({ type: EType.Articles, slug: mainArticle.attributes.slug, id: mainArticle.id }),
                )
              }
            />
          ) : (
            <MainArticleDetailed
              title={mainArticle.attributes.title}
              titleColor={mainArticle.attributes.titleColor || undefined}
              image={mainArticle.attributes.image}
              rubric={mainArticle.attributes.rubrics?.length ? mainArticle.attributes.rubrics[0] : undefined}
              viewsCount={mainArticle.attributes.numViews}
              commentsCount={mainArticle.attributes.commentsCount}
              articleUrl={buildPostUrl({ type: EType.Articles, slug: mainArticle.attributes.slug, id: mainArticle.id })}
              onClick={() =>
                handleArticleClick(
                  buildPostUrl({ type: EType.Articles, slug: mainArticle.attributes.slug, id: mainArticle.id }),
                )
              }
              onRubricButtonClick={() => handleRubricButtonClick(mainArticle.attributes?.rubrics[0]?.url)}
            />
          ))}

        {/* Прелоадер */}
        {!mainArticle && <Image borderRadius={0} src={''} theme="light" />}
      </div>

      <MainNews items={mainNews.items} />
    </div>
  );
};
